module.exports = __webpack_public_path__ + "img/digital.cfaef351.png";